var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{attrs:{"id":"master_app"}},[_c('v-app',{attrs:{"id":"app"}},[_c('project-report-details',{attrs:{"project_report":_vm.project_report,"settings":_vm.settings}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }